import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from './interface';
import { MSRFilterConfig } from './filters/MSRFilterConfig';

export const MicrosoftSecurityResearchTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.MSecR],
  provider: TenantProvider.ARTEMIS,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    FieldConfig: [],
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: false,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: [],
      Title: UATConstants.TenantTitles.MicrosoftSecurityResearch,
      ADOTitle: UATConstants.TenantADOText.MicrosoftSecurityResearch,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateMSRRequest,
          Key: UATConstants.CreateActionMenuKey.CreateMSRRequest,
          NodeName: '',
        },
      ],
      BulkUpload: false,
      DownloadTemplate: false,
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: false,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkDelete: false,
      BulkEditConfig: [],
      CreateRAID: false,
    },
    ManageAction: {
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: false,
          DiscussionInsights: false,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
      NewExperience: true,
      MandateFormPickers: [
        {
          formFieldName: 'assignedto',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner,
          apiFieldName: 'assignedto',
        },
      ],
    },
    ManageView: {
      isArtemisIntegrationEnabled: true,
      showAddViewButton: true,
      showAddFolderButton: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      defaultViewId: '35a2abd7-9e87-4c83-9e53-7d4bb39f3a5f',
      systemViewsFolderId: 'ac6f81bf-d89f-477f-bd3d-c76295f0a38e',
      sharedViewsFolderId: '9d82e528-5a3e-460d-8d53-e2335686a0a5',
    },
  },
};
// Generated by GitHub Copilot | Updated on: 2026-07-01 | 91 lines modified | Created Microsoft Security Research tenant configuration following Partner Skilling ARTEMIS structure
